export default __webpack_public_path__ + "static/media/Change_price.e61810e8.svg";